export const days = [
  {
    key: 'null',
    value: 'null',
    text: '',
  },
  {
    key: 'mon',
    value: 1,
    text: 'Monday',
  },
  {
    key: 'tues',
    value: 2,
    text: 'Tuesday',
  },
  {
    key: 'wed',
    value: 3,
    text: 'Wednesday',
  },
  {
    key: 'thur',
    value: 4,
    text: 'Thursday',
  },
  {
    key: 'fri',
    value: 5,
    text: 'Friday',
  },
  {
    key: 'sat',
    value: 6,
    text: 'Saturday',
  },
  {
    key: 'sun',
    value: 0,
    text: 'Sunday',
  },
];



// WEBPACK FOOTER //
// ./src/common/Constants/days.js